import gql from "graphql-tag";

export const USERS_QUERY = gql`
  query($name: String!, $page: Int) {
    users(name: $name, pagination: { page: $page }) {
      data {
        id
        firstName
        lastName
        business {
          name
          phone
        }
        blocked
      }
      pagination {
        currentPage
        totalCount
      }
    }
  }
`;

export const FACTOR_REQUESTS_QUERY = gql`
  query($page: Int) {
    factorRequests(pagination: { page: $page }) {
      data {
        id
        amount
        state
        business {
          name
          currency {
            code
            factor
          }
        }
      }
      pagination {
        currentPage
        totalCount
      }
    }
  }
`;

export const FIND_BUSINESS_QUERY = gql`
  query($id: Int!) {
    findBusiness(id: $id) {
      id
      name
      website
      phone
      rcNumber
      streetAddress
      city
      description
      yearOfIncorporation
      companySize
      customerType
      desiredLineOfCredit
      annualRevenue
      averageMonthlySpend
      tin
      businessAlias
      industryType
      entityType
      country {
        name
      }
      currency {
        name
        code
        factor
      }
      businessDocuments {
        id
        upload {
          url
        }
      }
      businessDirectors {
        firstName
        lastName
        address
        email
        phone
        country {
          name
        }
        title
        bvn
        dob
        city
        state
        identificationType
        identificationNumber
        businessDirectorDocuments {
          id
          upload {
            url
          }
        }
      }
    }
  }
`;

export const PENDING_BUSINESS_VERIFICATION_QUERY = gql`
  query($page: Int!) {
    pendingVerification(pagination: { page: $page }) {
      data {
        id
        owner {
          name
        }
        name
        phone
      }
      pagination {
        currentPage
        totalCount
      }
    }
  }
`;

export const FACTOR_REQUEST_QUERY = gql`
  query($id: Int!) {
    factorRequest(id: $id) {
      id
      amount
      state
      business {
        name
        website
        phone
        rcNumber
        streetAddress
        city
        description
        yearOfIncorporation
        companySize
        customerType
        businessCategory
        desiredLineOfCredit
        annualRevenue
        averageMonthlySpend
        tin
        businessAlias
        industryType
        entityType
        country {
          name
        }
        currency {
          code
          factor
        }
        businessDocuments {
          id
          url
        }
        businessDirectors {
          firstName
          lastName
          address
          email
          phone
          country {
            name
          }
          title
          bvn
          dob
          city
          state
          identificationType
          identificationNumber
          businessDirectorDocuments {
            id
            url
          }
        }
      }
      invoice {
        netAmount
        customer {
          name
        }
        dueDate
      }
    }
  }
`;

export const USER_PROFILE_QUERY = gql`
  query($id: Int!) {
    userProfile(id: $id) {
      id
      firstName
      lastName
      email
      blocked
      activated
      accountLocked
      business {
        id
        name
        website
        phone
        rcNumber
        streetAddress
        city
        description
        yearOfIncorporation
        companySize
        customerType
        desiredLineOfCredit
        annualRevenue
        averageMonthlySpend
        tin
        businessAlias
        industryType
        entityType
        accountBalance
        moneyIn
        moneyOut
        swipeCredit
        swipeCreditSpent
        swipeCreditInterest
        repaymentDueOn
        country {
          name
        }
        currency {
          name
          code
          factor
          symbol
        }
        businessDocuments {
          id
          upload {
            url
          }
        }
        businessDirectors {
          firstName
          lastName
          address
          email
          phone
          country {
            name
          }
          title
          bvn
          dob
          city
          state
          identificationType
          identificationNumber
          businessDirectorDocuments {
            id
            upload {
              url
            }
          }
        }
        creditWithdrawals {
          id
          amount
          interest
          dueOn
          repaid
          repaidOn
          repaymentAmount
        }
      }
    }
  }
`;

export const WAITLIST_QUERY = gql`
  query($page: Int) {
    waitlist(pagination: { page: $page }) {
      data {
        id
        email
        createdAt
      }
      pagination {
        currentPage
        totalCount
      }
    }
  }
`;

export const ADMIN_STATS = gql`
  query {
    adminStats
  }
`;

export const CREDIT_QUERY = gql`
  query($page: Int) {
    creditHistory(all: true, pagination: { page: $page }) {
      data {
        id
        business {
          name
          currency {
            code
            factor
          }
        }
        amount
        interest
        dueOn
        repaid
        repaidOn
        repaymentAmount
        createdAt
      }
      pagination {
        currentPage
        totalCount
      }
    }
  }
`;
